import ManualLogin from './ManualLogin';
export default ManualLogin;
